import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { clearActiveRoomId, getActiveRoomId } from '../lib/activeRoomSession';

const API_URL = 'https://apem.riderup.uk/api';

function getCoordinates() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Este dispositivo não oferece acesso à localização.'));
            return;
        }

        navigator.geolocation.getCurrentPosition(
            ({ coords }) => resolve({ latitude: coords.latitude, longitude: coords.longitude }),
            reject,
            { enableHighAccuracy: true, timeout: 12000, maximumAge: 5000 }
        );
    });
}

export default function PartyRoomPresence() {
    const { pathname } = useLocation();

    useEffect(() => {
        let running = false;
        let active = true;

        const heartbeat = async () => {
            if (!active || running || document.visibilityState === 'hidden') return;
            const roomId = getActiveRoomId();
            const token = localStorage.getItem('token');
            if (!roomId || !token) return;

            running = true;
            try {
                const coordinates = await getCoordinates();
                if (!active) return;
                await axios.post(`${API_URL}/rooms/${roomId}/heartbeat`, coordinates, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } catch (error) {
                if ([403, 404, 409, 410].includes(error.response?.status)) {
                    clearActiveRoomId();
                }
            } finally {
                running = false;
            }
        };

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') heartbeat();
        };

        const roomPageOwnsHeartbeat = pathname === '/home' || pathname.startsWith('/manage-room');
        if (roomPageOwnsHeartbeat) return undefined;

        heartbeat();
        const intervalId = window.setInterval(heartbeat, 30000);
        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            active = false;
            window.clearInterval(intervalId);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [pathname]);

    return null;
}
